export default class Path {
  static addPath(params) {
    let defaultOption = {
      id: 'path',
      name: '路径',
      coordType: 0,
      coordTypeZ: 0,
      type: 'Arrow06',
      color: '#ff0000',
      colorPass: '#0000FF',
      width: 40,
      tag: 'custominfo', // 用户自定标签，用户保存用户的扩展数据
      autoScale: false,
      lineDataId: '', // 对应本服务器上线数据对象，如果找到lineDataId，则下方的points不起作用。注意：此属性端渲染未生效
      points: []
    }
    let jsonData = Object.assign({}, defaultOption, params)
    delete jsonData.layerConfig
    window.appInstance.uniCall('addPath', jsonData, res => {
      console.log(`addPath`, jsonData, res);
    });
  }
  static async updatePathCoord(params) {
    let defaultOption = {
      id: 'path',
      name: '路径',
      coordType: 0,
      coordTypeZ: 0,
      isAppend: false,
      tag: 'custominfo',
      points: []
    }
    let jsonData = Object.assign({}, defaultOption, params)
    window.appInstance.uniCall('updatePathCoord', jsonData, res => {
      console.log('updatePathCoord', jsonData, res)
    })
  }
}
